import React, { PureComponent } from 'react';

class InvoiceListHeader extends PureComponent {

    render() {
        
        return (
        	<thead className="table-header">
	            <tr className="table-list-row row-header">
	            	<th className="table-list-col bold" style={{width: '100px'}}>
	            		發票號碼
	            		<div className="fix-row-header">發票號碼</div>
	            	</th>
	            	<th className="table-list-col bold" style={{width: '70px'}}>
		                期別
		                <div className="fix-row-header">期別</div>
		            </th>
					<th className="table-list-col bold" style={{width: '80px'}}>
		            	開立日期
		            	<div className="fix-row-header">開立日期</div>
		            </th>
		            <th className="table-list-col bold" style={{width: '140px'}}>
		            	訂單編號
		            	<div className="fix-row-header">訂單編號</div>
		            </th>
		            <th className="table-list-col bold" style={{width: '70px'}}>
		            	銷售額
		            	<div className="fix-row-header">銷售額</div>
		            </th>
		            <th className="table-list-col bold" style={{width: '70px'}}>
		            	營業稅
		            	<div className="fix-row-header">營業稅</div>
		            </th>
		            <th className="table-list-col bold" style={{width: '70px'}}>
		            	含稅總額
		            	<div className="fix-row-header">含稅總額</div>
		            </th>
		            <th className="table-list-col bold">
		            	買受人
		            	<div className="fix-row-header">買受人</div>
		            </th>
		            <th className="table-list-col bold" style={{width: '80px'}}>
		            	統一編號
		            	<div className="fix-row-header" >統一編號</div>
		            </th>
		            <th className="table-list-col bold" style={{width: '40px'}}>
		            	狀態
		            	<div className="fix-row-header">狀態</div>
		            </th>
		            <th className="table-list-col bold" >
		            	寄送
		            	<div className="fix-row-header">寄送</div>
		            </th>

		            <th className="table-list-col bold" >
		            	上傳
		            	<div className="fix-row-header">上傳</div>
		            </th>

		            <th className="table-list-col bold" style={{width: '40px'}}>
						操作
						<div className="fix-row-header">操作</div>
		            </th>					
	            </tr>
	        </thead>
        );
    }
}

export default InvoiceListHeader;


// WEBPACK FOOTER //
// ./src/components/invoice/InvoiceListHeader.jsx